import React from 'react'

export default function VisiGiftShoppingHistory() {
  return (
    <div>VisiGiftShoppingHistory</div>
  )
}
